export { default as ZoomInOutlineIcon } from './ZoomInOutlineIcon';
